import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// Triggers admin panel on:
// - Desktop: A + D + M keys pressed simultaneously
// - Mobile: 5-second long press on the footer logo (registered via the logoRef returned)
export function useAdminSecret() {
  const navigate = useNavigate();
  const pressedKeys = useRef(new Set());
  const longPressTimer = useRef(null);

  useEffect(() => {
    const onKeyDown = (e) => {
      const k = e.key?.toLowerCase();
      if (k === "a" || k === "d" || k === "m") {
        pressedKeys.current.add(k);
        if (
          pressedKeys.current.has("a") &&
          pressedKeys.current.has("d") &&
          pressedKeys.current.has("m")
        ) {
          pressedKeys.current.clear();
          navigate("/admin/login");
        }
      }
    };
    const onKeyUp = (e) => {
      const k = e.key?.toLowerCase();
      pressedKeys.current.delete(k);
    };
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("keyup", onKeyUp);
    };
  }, [navigate]);

  const longPressHandlers = {
    onPointerDown: () => {
      longPressTimer.current = setTimeout(() => {
        navigate("/admin/login");
      }, 5000);
    },
    onPointerUp: () => clearTimeout(longPressTimer.current),
    onPointerLeave: () => clearTimeout(longPressTimer.current),
    onPointerCancel: () => clearTimeout(longPressTimer.current),
  };

  return { longPressHandlers };
}
